import Header from '../../main-layout/header/Header';
import ProductCardContextProvider, { useProductCardContext } from '../../context/ProductCardContext';
import { UPSELL_TYPES } from '../../utils/constants';
import ProductUpSell from '../ProductUpSell';
import { viHeaderGrid } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ViHeader = ({
  className
}) => {
  const context = useProductCardContext();
  const {
    extraProps,
    upSell,
    shouldDisplayUpsell
  } = context;
  const viPromotionalPill = extraProps === null || extraProps === void 0 ? void 0 : extraProps.viPromotionalPill;
  const shouldDisplayContextUpsell = shouldDisplayUpsell && (upSell === null || upSell === void 0 ? void 0 : upSell.content);
  const upsellChildren = shouldDisplayContextUpsell || viPromotionalPill ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldDisplayContextUpsell && /*#__PURE__*/_jsx(ProductUpSell, {
      upSell: upSell
    }), viPromotionalPill && /*#__PURE__*/_jsx(ProductUpSell, {
      upSell: {
        content: viPromotionalPill,
        type: UPSELL_TYPES.PROMOTIONAL
      }
    })]
  }) : undefined;
  return /*#__PURE__*/_jsx(ProductCardContextProvider, {
    productData: {
      ...context,
      shouldDisplayUpsell: false
    },
    children: /*#__PURE__*/_jsx(Header, {
      className: className,
      customGrid: viHeaderGrid,
      children: upsellChildren
    })
  });
};
export default ViHeader;
//# sourceMappingURL=ViHeader.js.map